import React from "react";
import { Avatar, Card } from "antd";

const activityDetail = [
  {
    name: "Alice Johnson",
    category: "Project Success",
    nominationDate: "2025-12-04",
    reason: "Successful and quick in finishing tasks",
    points: 1000,
  },
  {
    name: "Bob Martinez",
    category: "Delivery Excellence",
    nominationDate: "2025-12-03",
    reason: "Consistently exceeding expectations and meeting deadlines",
    points: 800,
  },
  {
    name: "Clara Lee",
    category: "Quality & Accuracy",
    nominationDate: "2025-12-02",
    reason: "Outstanding attention to detail in documentation",
    points: 750,
  },
  {
    name: "Daniel Kim",
    category: "Collaboration & Knowledge",
    nominationDate: "2025-12-01",
    reason: "Mentoring junior staff and sharing knowledge generously",
    points: 900,
  },
  {
    name: "Eva Gonzales",
    category: "Innovation & Creativity",
    nominationDate: "2025-11-30",
    reason: "Proposed a new process that improved efficiency by 20%",
    points: 1100,
  },
  {
    name: "Frank Liu",
    category: "Positive Workplace Culture",
    nominationDate: "2025-11-29",
    reason: "Promoted team morale and inclusivity consistently",
    points: 650,
  },
  {
    name: "Grace Patel",
    category: "Technology & AI Adoption",
    nominationDate: "2025-11-28",
    reason: "Implemented AI tools that streamlined reporting",
    points: 1200,
  },
  {
    name: "Hiroshi Tanaka",
    category: "Team Player Award",
    nominationDate: "2025-11-27",
    reason: "Went above and beyond to support cross-functional projects",
    points: 700,
  },
];


const ActivitiesCard = () => {
  return (
    <>
      <div className="flex flex-col gap-3">
        {activityDetail.map((item) => {

          return (
            <Card
              key={item.employeeId}
              className="rounded-xl"
            >
              <div className="flex justify-between items-center">
                <div className="flex justify-between items-center gap-3">
                  <Avatar
                    size={40}
                    className="bg-gradient-to-br from-emerald-500 to-violet-500 overflow-hidden"
                  >
                    {item.name?.split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </Avatar>
                  <div class="flex-1">
                    <p class="font-medium text-[13px] dark:text-zinc-100">{item.name}</p>
                    <p class="text-[11px] text-muted-foreground dark:text-zinc-400 line-clamp-1">{item.category}: {item.reason}</p>
                  </div>
                </div>
                <div className="flex flex-col items-center justify-end">
                  <span class="rounded-xl border px-2 py-0.5 bg-gradient-to-r gradient emerald text-white text-[11px] font-semibold">
                    +{item.points} credits
                  </span>
                  <p class="text-[10px] text-muted-foreground dark:text-zinc-500 mt-1">{item.nominationDate}</p>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </>
  );
};

export default ActivitiesCard;
